var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{class:['block px-3 py-2 rounded-md', _vm.isActive ? 'bg-sky-500 text-white' : 'bg-slate-50'],attrs:{"href":_vm.href}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }